import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../../constants';

// Интерфейсы для автоподбора парка
export interface CargoItem {
  id: string | number;
  name?: string;
  lengthMm: number;
  widthMm: number;
  heightMm: number;
  weightKg: number;
  stackable?: boolean;
  rotAllowed?: boolean;
}

export interface VehicleSelectionHint {
  requiresReefer?: boolean;
  isOversizedHeavy?: boolean;
}

export interface AutoPlanRequest {
  items: CargoItem[];
  selectionHint?: VehicleSelectionHint;
  maxVehicles?: number;
  gapMm?: number; // Зазор между грузами в мм
  allowStacking?: boolean; // Глобальное разрешение штабелирования
  availableVehicleIds?: string[]; // Доступные типы транспорта для выбора
}

export interface VehicleSpec {
  id: string;
  name: string;
  bodyType: string;
  internalLengthMm: number;
  internalWidthMm: number;
  internalHeightMm: number;
  maxPayloadKg: number;
  notes?: string;
}

export interface PlacedItem extends CargoItem {
  xMm: number;
  yMm: number;
  zMm: number;
  rotated?: boolean;
}

export interface VehiclePlan {
  vehicle: VehicleSpec;
  items: PlacedItem[];
  usedPayloadKg: number;
}

export interface AutoPlanResponse {
  vehicles: VehiclePlan[];
  unplacedItems?: CargoItem[];
  summary: {
    totalItems: number;
    placedItems: number;
    unplacedItems: number;
    totalWeight: number;
    placedWeight: number;
  };
}

export const packingApi = createApi({
  reducerPath: 'packingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_BASE_URL}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Packing'],
  endpoints: (builder) => ({
    autoPlan: builder.mutation<AutoPlanResponse, AutoPlanRequest>({
      query: (body) => ({
        url: '/packing/auto-plan',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Packing'],
    }),
  }),
});

export const { useAutoPlanMutation } = packingApi;
